import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { indicadorAvalApi } from "../../services/Api";
import { ListApi, FormApi, List, CrudForm, Select } from "elentari";
import genders, { getGenderFromValue } from "../../utils/genders";
import exercisesTypes from "../../utils/exercisesTypes";
import exercisesClassifications from "../../utils/exercisesClassifications";

export function IndicadorAvalList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      tipoExercicio: {
        label: "Tipo exercício",
      },
      nome: {
        label: "Classificação",
      },
      genero: {
        label: "Genero",
        format: (genero) => getGenderFromValue(genero).label,
      },
      idadeMin: {
        label: "Idade mínima",
      },
      idadeMax: {
        label: "Idade máxima",
      },
      parametroMin: {
        label: "Parâmetro mínimo",
      },
      parametroMax: {
        label: "Parâmetro máximo",
      },
    },
  };

  return (
    <ListApi api={indicadorAvalApi}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          labelNew="Novo"
          deleteItem={handleDelete}
          onClickEdit={(item) =>
            props.history.push(`/indicador-aval/${item.id}`)
          }
          onClickNew={() => props.history.push("/indicador-aval/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function IndicadorAvalForm(props) {
  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        tipoExercicio: data.tipoExercicio ? data.tipoExercicio : undefined,
        genero: data.genero ? data.genero : undefined,
        nome: data.nome ? data.nome : undefined,
        idadeMin: data.idadeMin ? +data.idadeMin : undefined,
        idadeMax: data.idadeMax ? +data.idadeMax : undefined,
        parametroMin: data.parametroMin ? +data.parametroMin : undefined,
        parametroMax: data.parametroMax ? +data.parametroMax : undefined,
      },
    });
    return result;
  };

  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
    tipoExercicio: values.tipoExercicio ? undefined : "Obrigatório",
    genero: values.genero ? undefined : "Obrigatório",
    idadeMin: values.idadeMin ? undefined : "Obrigatório",
    idadeMax: values.idadeMax ? undefined : "Obrigatório",
    parametroMin: values.parametroMin ? undefined : "Obrigatório",
    parametroMax: values.parametroMax ? undefined : "Obrigatório",
  });

  return (
    <FormApi
      api={indicadorAvalApi}
      submitDecorator={submitDecorator}
      {...props}
    >
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs={4}>
                  <Field
                    fullWidth
                    autoFocus
                    component={Select}
                    options={exercisesTypes}
                    label="Tipo de exercício"
                    name="tipoExercicio"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    fullWidth
                    autoFocus
                    component={Select}
                    options={genders}
                    label="Gênero"
                    name="genero"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Field
                    fullWidth
                    autoFocus
                    component={Select}
                    options={exercisesClassifications}
                    label="Classificação"
                    name="nome"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    type="number"
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Idade mínima"
                    name="idadeMin"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    type="number"
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Idade máxima"
                    name="idadeMax"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    type="number"
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Parâmetro mínimo"
                    name="parametroMin"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    type="number"
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Parametro máximo"
                    name="parametroMax"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
